// --- Libraries
import bytes from 'bytes';
import crypto from 'crypto';
import events from 'events';
import Promise from 'bluebird';
import pusage from 'roar-pidusage';
import request from 'requestretry';
import unhandledRejection from 'unhandled-rejection';
import util from 'util';
// --- Modules
import configure from './configure';
import logger, { LEVELS } from './resources/Logger';
import { SecurityZones, setTemplate, payload } from './resources/Node';
import { formatError, formatErrorToJSON, execScript, generateHash, parsePowershellOutput } from './utils';

const ALGORITHM = 'AES-256-CBC';
const HMAC_ALGORITHM = 'SHA256';

var program = {};

global.sdkEventEmitter = new events.EventEmitter();
global.startTime = (new Date()).getTime();

let testPayload;
let stats = {
  cpu: 0,
  cpuCount: 0,
  memory: 0
};

let rejectionEmitter = unhandledRejection({
  timeout: 120
});

global.sdkEventEmitter.on('update-pid', (pid) => {
  console.log('changing pid', pid);
  if (global.currentPid) {
    pusage.unmonitor(global.currentPid);
  }

  global.currentPid = pid;

  if (global.currentPid) {
    setTimeout(() => {
      pusage.stat(global.currentPid, function(err, stat) {
        if (stat) {
          if (stat.cpu && stat.cpu > stats.cpu) {
            stats.cpu += stat.cpu;
            stats.cpuCount++;
          }

          if (stat.memory && stat.memory > stats.memory) {
            stats.memory = stat.memory;
          }
        }

        global.gc();
      });
    }, 1000);
  }
});
global.sdkEventEmitter.emit('update-pid', process.pid);

function processPayload(data) {
  // logger.log(program.data.TimelineID, program.data.ACCESS_KEY, { Status: 'Packaging', PackagedOn: new Date() });
  console.log('HELLO INSPECTOR #1', program.data.ACCESS_KEY_SECRET);
  // logger.inspector('update', configure.inspector.name, 'Completed handler for all templates in the payload');
  // logger.output(6, 'Inspector Start', 'Recieved payload, starting inspector...', 20, { '_InspectorName': configure.inspector.name, '_InspectorVersion': configure.inspector.version });
  const IV = new Buffer(crypto.randomBytes(16)); // ensure that the IV (initialization vector) is random

  // Need to serialize our nodes for sending across the wire
  //payload.nodes = payload.nodes.map(node => node.serialize());
  console.log('HELLO INSPECTOR #1a', program.data.ACCESS_KEY_SECRET);
  //console.log('HELLO INSPECTOR #1b', util.inspect(payload, { showHidden: false, depth: null }));

  console.log('HELLO INSPECTOR #2', ALGORITHM, Buffer.from(program.data.ACCESS_KEY_SECRET, 'hex'), IV);
  const encryptor = crypto.createCipheriv(ALGORITHM, Buffer.from(program.data.ACCESS_KEY_SECRET, 'hex'), IV);
  console.log('HELLO INSPECTOR #2a');
  encryptor.setEncoding('hex');
  console.log('HELLO INSPECTOR #2b');
  encryptor.write(JSON.stringify(Object.assign({
    TimelineID: program.data.TimelineID,
    ServiceProviderID: program.data.ServiceProviderID,
    ScannerID: program.data.ScannerID,
    ScannerVersion: program.data.ScannerVersion,
    ControllerDeploymentID: program.data.ControllerDeploymentID
  }, data)).replace(/[^\x00-\x7F]/g, ''));
  console.log('HELLO INSPECTOR #2c');
  encryptor.end();

  console.log('HELLO INSPECTOR #2', data);
  const cipherText = encryptor.read();

  console.log('HELLO INSPECTOR #3', 'cipherText', program.data.ACCESS_KEY_SECRET);
  const hmac = crypto.createHmac(HMAC_ALGORITHM, program.data.ACCESS_KEY_SECRET);
  hmac.update(cipherText);
  hmac.update(IV.toString('hex'));

  console.log('HELLO INSPECTOR #4', program.data.ACCESS_KEY, process.env.NODE_ENV);
  /*console.log('HELLO INSPECTOR #111', `${configure.apiURL()}/scan`, JSON.stringify({
    content: cipherText + '$' + IV.toString('hex') + '$' + hmac.digest('hex')
  }));*/

  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'prod') {
      console.log('HELLO INSPECTOR #5', `${configure.apiURL()}/scan`);
      //console.log('HELLO INSPECTOR #a', cipherText);
      console.log('HELLO INSPECTOR #b', IV.toString('hex'));

      const hmacFinal = hmac.digest('hex');
      console.log('HELLO INSPECTOR #c', hmacFinal);

      var theContent = cipherText + '$' + IV.toString('hex') + '$' + hmacFinal;
      var ss = theContent.split('$');
      console.log('cipher length', Buffer.byteLength(theContent, 'utf8'), ss.length);
      console.log('1', ss[1]);
      console.log('2', ss[2]);

      request({
        method: 'POST',
        url: `${configure.apiURL()}/scan`,
        json: true,
        timeout: 60000,
        body: {
          content: theContent
        },
        gzip: true,
        maxAttempts: 1,
        retryDelay: 60000,  // (default) wait for 60s before trying again
        retryStrategy: request.RetryStrategies.HTTPOrNetworkError, // (default) retry on 5xx or network errors
        headers: {
          'Authorization': program.data.ACCESS_KEY,
          'Accept': 'application/json'
        }
      }, (error, response, body) => {
        console.log('abc', response, error, body);
        if (error) {
          logger.log(program.data.TimelineID, program.data.ACCESS_KEY, { Status: 'Failed', log: { Level: LEVELS.ERROR, Message: 'Inspector failed to send payload to Roar API successfully, exiting...\n\n' + (error ? formatError(error) : '') } });
          reject();
        }

        resolve();
      });
    } else {
      resolve();
    }
  });
}

function run(handler, options) {
  const startTime = (new Date()).getTime();

  program.data = {};
  program.data = process.argv[3];

  program.data = JSON.parse((new Buffer(program.data, 'hex')).toString('ascii'));

  process.on('uncaughtException', (err) => {
    console.error('uncaughtException', (err ? formatError(err) : ''));
    logger.log(program.data.TimelineID, program.data.ACCESS_KEY, { Status: 'Failed', log: { Level: LEVELS.ERROR, Message: 'Unknown failure occurred for inspector, exiting...\n\n' + (err ? formatError(err) : '') } });
    process.exit(1);
  });

  rejectionEmitter.on('unhandledRejection', (error, promise) => {
    console.error('unhandledRejection', (error ? formatError(error) : ''));
    logger.log(program.data.TimelineID, program.data.ACCESS_KEY, { Status: 'Failed', log: { Level: LEVELS.ERROR, Message: 'Unknown failure occurred for inspector, exiting...\n\n' + (error ? formatError(error) : '') } });
    process.exit(1);
  });

  console.log('HELLO INSPECTOR #0', util.inspect(program.data, { showHidden: false, depth: null }));
  //logger.output(6, 'Inspector Start', 'Recieved payload, starting inspector...', 20, { '_InspectorName': configure.inspector.name, '_InspectorVersion': configure.inspector.version, '_ServiceProviderID': `${program.data.ServiceProviderID}`, '_ScannerID': `${program.data.ScannerID}`, '_ControllerDeploymentID': `${program.data.ControllerDeploymentID}` });

  global.ACCESS_KEY = program.data.ACCESS_KEY;
  global.ACCESS_KEY_SECRET = program.data.ACCESS_KEY_SECRET;

  options = options || {};
  Promise.map(program.data.templates,
    (d) => new Promise((resolve, reject) => {
      setTemplate(d);
      if (!options.pause) {
        handler(program.data, d, resolve, reject);
      } else {
        setTimeout(() => {
          handler(program.data, d, resolve, reject);
        }, options.pause);
      }
    })
  )
  .then(() => {
    if (options.limit) {
      let startIndex = 0;
      Promise.mapSeries(payload.nodes, (node, index) => {
        const endTime = (new Date()).getTime();
        const totalTime = endTime - global.startTime;
        if (Buffer.byteLength(JSON.stringify(payload.nodes.slice(startIndex, index + 1)), 'utf8') >= bytes(options.limit)) {
          // need to make into promises
          const oldStartIndex = startIndex;
          startIndex = index + 1;
          const nodeSet = payload.nodes.slice(oldStartIndex, index + 1).map(node => node.serialize());
          return processPayload({
            nodes: nodeSet,
            relationships: [],
            stats: Object.assign({}, { StartTime: global.startTime, EndTime: (new Date()).getTime(), TotalTime: totalTime, AvgCPU: Number.isNaN(stats.cpu / stats.cpuCount) ? 0 : stats.cpu / stats.cpuCount, MaxMemory: stats.memory })
          });
        } else {
          return Promise.resolve();
        }
      })
      .then(() => {
        const endTime = (new Date()).getTime();
        const totalTime = endTime - global.startTime;
        global.sdkEventEmitter.emit('update-pid', null);

        processPayload({
          nodes: [],
          relationships: payload.relationships,
          stats: Object.assign({}, { StartTime: global.startTime, EndTime: (new Date()).getTime(), TotalTime: totalTime, AvgCPU: Number.isNaN(stats.cpu / stats.cpuCount) ? 0 : stats.cpu / stats.cpuCount, MaxMemory: stats.memory })
        })
        .then(() => {
          process.exit(0);
        });
      });
    } else {
      if (!testPayload) {
        payload.nodes = payload.nodes.map(node => node.serialize());
      }

      const endTime = (new Date()).getTime();
      const totalTime = endTime - global.startTime;
      global.sdkEventEmitter.emit('update-pid', null);

      processPayload(testPayload ? testPayload : Object.assign(payload, { stats: { StartTime: global.startTime, EndTime: (new Date()).getTime(), TotalTime: totalTime, AvgCPU: stats.cpu / stats.cpuCount, MaxMemory: stats.memory } }))
      .then(() => {
        process.exit(0);
      });
    }
  }).catch((err) => {
    console.error('caught error', (err ? formatError(err) : ''));
    logger.log(program.data.TimelineID, program.data.ACCESS_KEY, { Status: 'Failed', log: { Level: LEVELS.ERROR, Message: 'Inspector failed during running of handler, exiting...\n\n' + (err ? formatError(err) : '') } });
    global.sdkEventEmitter.emit('update-pid', null);
    process.exit(1);
  });
}

function addRelationship(entity, node1, node2, relationship, configuration) {
  payload.relationships.push({
    EntityID: entity,
    Node1: typeof node1 === 'object' ? node1.getUniqueCompositeKey() : node1,
    Node2: typeof node1 === 'object' ? node2.getUniqueCompositeKey() : node2,
    Relationship: relationship
  });
}

function addSuggestion(obj) {
  payload.suggestions.push(obj);
}

function overridePayload(obj) {
  testPayload = obj;
}

function getPayload() {
  return payload;
}

function payloadToJSONString() {
  return {
    nodes: payload.nodes.map(node => node.serialize()),
    relationships: payload.relationships,
    suggestions: payload.suggestions
  };
}

export default {
  version: configure.version,
  run,
  addRelationship,
  addSuggestion,
  getPayload,
  overridePayload,
  payloadToJSONString,

  // -- Modules
  CloudItem: require('./resources/CloudItem'),
  CloudService: require('./resources/CloudService'),
  Data: require('./resources/Data'),
  DHCP: require('./resources/DHCP'),
  Firewall: require('./resources/Firewall'),
  Host: require('./resources/Host'),
  LocalDNS: require('./resources/LocalDNS'),
  LocalService: require('./resources/LocalService'),
  NetworkDevice: require('./resources/NetworkDevice'),
  NetworkNode: require('./resources/NetworkNode'),
  Policy: require('./resources/Policy'),
  PublicDNS: require('./resources/PublicDNS'),
  RegisteredDomain: require('./resources/RegisteredDomain'),
  Registrar: require('./resources/Registrar'),
  Router: require('./resources/Router'),
  SecurityDevice: require('./resources/SecurityDevice'),
  Subnet: require('./resources/Subnet'),
  Switch: require('./resources/Switch'),
  User: require('./resources/User'),

  SecurityZones,

  // --- Helpers
  logger,
  LEVELS,
  formatError, formatErrorToJSON, execScript, generateHash, parsePowershellOutput
};
